// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOG_POST_EDIT_MENU = "Uprav";
export const BLOG_REPORT_POST = "Nahl\u00e1sit p\u0159\u00edsp\u011bvek";
export const DELETE = "Vyma\u017e";
export const GROUP_DONT_SHOW_POSTS_FROM_group = "Nezobrazuj p\u0159\u00edsp\u011bvky skupiny %(group)s";
export const GROUP_LEAVE_group = "Opus\u0165 skupinu %(group)s";
export const PB_IGNORE_POSTS_FROM_USER_username = "Nezobrazuj mi p\u0159\u00edsp\u011bvky od %(username)s";
export const PIN_POST = "P\u0159ipnout nahoru";
export const REMOVE_FROM_FEED = "Odstranit z feedu";
export const REMOVE_FROM_PROFILE = "Odeber z profilu";
export const RETURN_TO_FEED = "Vr\u00e1tit do feedu";
export const SEND_HEART_TO_username = "Po\u0161li srd\u00ed\u010dko %(username)s";
export const SHOW_USERS_WHO_LIKED_THIS_POST = "Zobraz u\u017eivatelky, kter\u00fdm se to l\u00edb\u00ed";
export const UNPIN_POST = "Zru\u0161it p\u0159ipnut\u00ed";
